import React, { useRef, useEffect, useState, useContext } from "react";
import "./App.scss";

import Helmet from "react-helmet";
import ProgressBar from "react-scroll-progress-bar";
import { Header } from "./components/organisms/header/header";
import { Article } from "./components/organisms/article/article";
import { ThemeContext, themes } from "./context";
import { Description } from "./components/atoms/description"

function App() {
  let ref = useRef(null);
  let [height, setHeight] = useState(100);

  useEffect(() => {
    const handleResize = () => {
      if (ref.current) {
        setHeight(ref.current.clientHeight);
      }
    };
    window.onload = handleResize;
    window.addEventListener("resize", handleResize);
  }, [ref]);

  const name = "Yasmin Pessoa";

  const { themeName, imageData } = useContext(ThemeContext);

  return (
    <div className="god">
      <Helmet
        bodyAttributes={{
          class: themeName
        }}
      />
      <ProgressBar bgcolor={themes[themeName].color} />
      <div className="wrapper">
        <Header name={name} />
        <main ref={ref} className={themeName}>
          <Article getHeight={height} />
        </main>
        <aside>
          <Description description={imageData.description} response={imageData.response} />
        </aside>
        <p className="clear"></p>
        <footer>
          Design principles list and quotes from{" "}
          <a href="https://stackoverflow.com/questions/45514676/react-check-if-element-is-visible-in-dom">
            this article
          </a>{" "}
          by David Rhyne. Built with <a href="https://reactjs.org/">React</a>.
        </footer>
      </div>
    </div>
  );
}

export default App;
